import React from "react";

export type TBackLinkIconProps = React.SVGAttributes<SVGElement>;

export function BackLinkIcon({ ...rest }: TBackLinkIconProps) {
  return (
    <svg
      viewBox="0 0 40 40"
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4639 20L24 14.2858L22.7543 13L16 19.9716L16.0274 20L16 20.0283L22.7543 26.9999L24 25.7142L18.4639 20Z"
        fill="#7F94A1"
      />
    </svg>
  );
}
